import SignUpForm from "./Register/SignUpForm";

const RegisterPage = () => {
  return (
  <div className="flex items-center justify-center sm:h-screen w-screen bg-section-gradient">
  <SignUpForm />
</div>

  );
};

export default RegisterPage;
